import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./index.scss";

ReactDOM.render(
    <React.StrictMode>
        <Router>
            <Suspense fallback={<div>Need to make a loader @Santi</div>}>
                <ScrollToTop>
                    <App />
                </ScrollToTop>
            </Suspense>
        </Router>
    </React.StrictMode>,
    document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
